import { createFileRoute } from '@tanstack/react-router';

import { LoadingPage } from '@nesso/ui/blocks/loading-page';

import { ServicesPage, servicesBeforeLoad } from '@/pages/settings/services';

export const Route = createFileRoute('/settings/services')({
    beforeLoad: servicesBeforeLoad,
    component: ServicesPage,
    pendingComponent: LoadingPage,
});
